import {useParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {AttachmentClassificationForm} from 'src/app/attachment-classifications/AttachmentClassificationForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const ViewAttachmentClassificationPage = () => {
  useSetDocumentTitle('View Attachment Classification');
  const {id} = useParams();

  return (
    <ContentWrapper>
      {id !== undefined && (
        <AttachmentClassificationForm id={Number(id)} mode="view" />
      )}
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AttachmentClassificationView(':id'),
  element: <ViewAttachmentClassificationPage />,
  module: ModuleEnum.AttachmentClassifications,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default ViewAttachmentClassificationPage;
